module.exports = __webpack_public_path__ + "img/np.27f0f4e7.svg";